import { ReactNode } from 'react'

type GridCasesLayoutProps = {
  children: ReactNode[]
}

const GridCasesLayout = ({ children }: GridCasesLayoutProps) => {
  return (
    <div className="grid grid-cols-1 auto-rows-fr md:grid-cols-2 lg:grid-cols-3 gap-8 my-8">
      {children}
    </div>
  )
}

export default GridCasesLayout
